// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-nav-tool {\n  /*原先 width: 200px;\r\n    height: 138px; */\n  width: 1.041667rem;\n  height: 0.197917rem;\n  margin-top: 0.052083rem;\n  /* background: #ffffff;  */\n  box-shadow: 0 0.010417rem 0.052083rem 0 rgba(153, 153, 153, 0.3) !important;\n  border-radius: 0.052083rem !important;\n  border: none !important;\n}\n.el-tooltip__popper.is-light {\n  margin-top: 0.0625rem !important;\n}\n.slide-nav-tool .popper__arrow {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
